import { doodBlockConfig } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const CONTAINER_LEGACY_FIELD_ORDER = [
  "container_blocks",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  containerBlockDescriptor: _generatedContainerBlockDescriptor,
  containerBlockBlocDefinition,
  containerBlockDashboardLayout,
  containerBlockConfig,
  containerBlockResolveConfig,
  containerBlockProperties,
} = doodBlockConfig(
  {
    hideFromPicker: true,
    name: "Container",
    componentType: "ContainerBlockComponent",
    category: "layout",
    description: "Responsive container for child blocks.",
    keywords: ["container", "layout", "responsive"],
    sharedFields: {},
    slots: [{ key: "container_blocks", name: "pages.blocks.container.container-blocks.label", accept: "all", slotItemFormat: "positionedBlocks" }],
  },

  () => ({}),

  () => ({
    tabs: [
      {
        label: "pages.blocks.container.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.container.fieldset.blocks.label",
            fields: ["container_blocks"],
          },
        ],
      },
    ],
  })
);

export function containerBlockDescriptor(): IBlockDescriptor;
export function containerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function containerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedContainerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedContainerBlockDescriptor,
    containerBlockProperties,
    fieldOrder,
  );
}

export {
  containerBlockBlocDefinition,
  containerBlockDashboardLayout,
  containerBlockConfig,
  containerBlockResolveConfig,
  containerBlockProperties,
};

export type ContainerBlockConfig = typeof containerBlockConfig;
